const allSourceFields = {
  discount: {
    sourceName: 'דיסקונט',
    displayName: 'דיסקונט',
    backendName: 'DiscountBank',
    sortPriority: 10,
    fields: {
      idNumber: {
        key: 'idNumber',
        name: 'מספר זהות',
        type: 'text',
        validation: 'id',
      },
      password: {
        key: 'password',
        name: 'סיסמה קבועה',
        type: 'password',
        renew: true,
        validation: 'min-length:6|not-he',
      },
      identityCode: {
        key: 'identityCode',
        name: 'קוד מזהה',
        type: 'text',
        validation: 'not-he|not-special',
      },
    },
    links: {
      homepage: 'https://www.discountbank.co.il',
      login: 'https://www.discountbank.co.il/DB/private',
      signup: 'https://www.discountbank.co.il/DB/private/join',
    },
    logoFile: 'discount-large.svg',
    logoFileStacked: 'discount-small.svg',
    instructions: 'Discount.vue',
    type: 'bank',
    hidden: true,
  },
  'discount-api': {
    sourceName: 'דיסקונט ישיר',
    displayName: 'דיסקונט ישיר',
    backendName: 'discountApi',
    sortPriority: 10,
    fields: {
      idNumber: {
        key: 'idNumber',
        name: 'מספר זהות',
        type: 'text',
        validation: 'exact-length:9|id',
      },
    },
    links: {
      homepage: 'https://www.discountbank.co.il',
      login: 'https://www.discountbank.co.il/DB/private',
      signup: 'https://www.discountbank.co.il/DB/private/join',
    },
    logoFile: 'discount-large.svg',
    logoFileStacked: 'discount-small.svg',
    instructions: 'DiscountApi.vue',
    type: 'bank',
  },
  discountBase: {
    sourceName: 'דיסקונט בסיס',
    displayName: 'דיסקונט',
    backendName: 'DiscountBase',
    logoFile: 'discount-large.svg',
    type: 'bank',
    sortPriority: 10,
    hidden: true,
  },
};

export default {
  allSourceFields,
};
